import { useQuery } from '@tanstack/react-query';
import { appointmentsApi, Appointment } from '../../api/appointments';
import { CalendarDays, Clock } from 'lucide-react';
import { ScrollArea } from '@/components/ui/scroll-area';

function formatTime(isoString: string): string {
  const date = new Date(isoString);
  return date.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
}

export function AgendaWidget() {
  const today = new Date().toISOString().split('T')[0];

  const { data: appointments, isLoading } = useQuery<Appointment[]>({
    queryKey: ['appointments', 'today'],
    queryFn: () => appointmentsApi.list({ date_from: today, date_to: today }),
  });

  const todaysAppointments = appointments?.filter((a) => {
    const apptDate = new Date(a.datetime_start).toISOString().split('T')[0];
    return apptDate === today;
  }) || [];

  return (
    <div className="mt-6 pt-4 border-t border-border">
      <h2 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-3 px-3 flex items-center gap-1.5">
        <CalendarDays className="size-3.5" />
        Agenda Oggi
      </h2>

      {isLoading ? (
        <div className="px-3 py-2 text-sm text-muted-foreground">Caricamento...</div>
      ) : todaysAppointments.length > 0 ? (
        <ScrollArea className="h-48">
          <div className="space-y-1.5 pr-3">
            {todaysAppointments.map((appt) => (
              <div
                key={appt.id}
                className="px-3 py-2 bg-muted/30 rounded-lg border border-border text-sm hover:bg-muted/50 transition-colors"
              >
                <div className="flex items-center justify-between">
                  <span className="font-medium text-foreground flex items-center gap-1">
                    <Clock className="size-3 text-muted-foreground" />
                    {formatTime(appt.datetime_start)}
                  </span>
                  <span className="text-xs text-muted-foreground bg-muted px-1.5 py-0.5 rounded">
                    {appt.visit_type}
                  </span>
                </div>
                {appt.patient_name && (
                  <p className="text-xs text-muted-foreground mt-0.5 truncate">
                    {appt.patient_name}
                  </p>
                )}
                {appt.vet_name && (
                  <p className="text-[11px] text-muted-foreground/60 mt-0.5">
                    Dr. {appt.vet_name}
                  </p>
                )}
              </div>
            ))}
          </div>
        </ScrollArea>
      ) : (
        <div className="px-3 py-2 text-sm text-muted-foreground">
          Nessun appuntamento oggi
        </div>
      )}
    </div>
  );
}
